// import { red } from "@material-ui/core/colors";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { Box, Button, CircularProgress, Grid, IconButton, Link, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from "@mui/material";
import red from '@mui/material/colors/red'
import { makeStyles } from "@mui/styles";
import clsx from 'clsx';
import moment from "moment";
import { useSnackbar } from 'notistack';
import React from "react";

import { DataAPIContext, GET_ONE } from "../api";
import { copyTextToClipboard } from "../utils";

const useStyles = makeStyles(theme => ({
    modalContent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        height: '80%',
        overflowY: 'scroll',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #bbb',
        borderRadius: '5px',
        // boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    gridRoot: {
        height: '100%',
        width: '100%',
    },
    tableCell: {
        verticalAlign: 'top'
    },
    tableRowValidation: {
        background: red[100]
    },
    tableRowException: {
        background: red[300],
    }
}))

const getActionDisplay = (x) => {
    return {
        0: "cache",
        1: "delete",
    }[x];
}

const getStatusDisplay = (x) => {
    // PROCESSING = 0
    // CACHED = 1
    // FAILED_VALIDATION = 2
    // IS_FRESH = 3
    // NOT_PUBLISHED = 4
    // EXCEPTION = 5
    return {
        0: "processing",
        1: "cached",
        2: "failed validation",
        3: "unchanged - cache is fresh",
        4: "object is not published",
        5: "error"
    }[x];
}

export const CacheRefreshHistory = (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const classes = useStyles();
    const theme = useTheme();
    const [current, setCurrent] = React.useState(null);
    const [data, setData] = React.useState(null);
    const [details, setDetails] = React.useState(null);
    const { enqueueSnackbar } = useSnackbar();

    const onClose = () => {
        setDetails(null);
        setData(null);
        props.onClose && props.onClose();
    }

    const onLoadDetails = (row) => {
        dataAPI(GET_ONE, props.resource, {
            id: props.id,
            urlSuffix: 'cache_history_data',
            filter: {
                hrec: row.id
            }
        }).then(res => {
            console.log('details res', res);
            setDetails(res.data);
        })
    }

    const onLoadList = (row) => {
        dataAPI(GET_ONE, props.resource, {
            id: props.id,
            urlSuffix: 'cache_history',
        }).then(res => {
            console.log('data res', res);
            setData(res.data);
        })
    }

    const onCloseData = () => {
        setDetails(null);
    }

    React.useEffect(() => {
        console.log('useEffect', !!data, !props.open);
        if (!!data || !props.open) { return; }
        let active = true;
        dataAPI(GET_ONE, props.resource, {
                id: props.id,
                urlSuffix: 'cache_current/'
            }).then(res => {
                console.log('got current', res, active);
                setCurrent(res.data);
            });
        return () => { active = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open, data]);

    const getDetails = (row) => {
        if (row.status === 0) { return <Typography variant="body2">Update in progress</Typography>; }
        else if (row.status === 1) { return <Typography variant="body2">Cached successfully (<Link onClick={ev => onLoadDetails(row)} target="_blank">{row.size} bytes</Link>)</Typography>; }
        else if (row.status === 2) {
            if (row.validation_errors && row.validation_errors.errors) {
                const list = row.validation_errors.errors.map(x => (<li>
                    {
                        x.constructor === String ?
                            x
                            : 
                            <>
                                <strong>{x.message}</strong><br/><pre>{JSON.stringify(x.object, null, 4)}</pre>
                            </>
                    }
                    </li>)
                );
                return <>
                    <Typography variant="body1">Validation errors</Typography>
                    <ul>{list}</ul>
                </>;
            } else {
                return <Typography variant="body2">Validation failed but no errors reported</Typography>;
            }
        } else if (row.status === 3) {
            return <Typography variant="body2">Recaching wasn't performed since cache isn't stale</Typography>;
        } else if (row.status === 4) {
            return <Typography variant="body2">Object was marked as deleted because it's not published</Typography>;
        } else if (row.status === 5) {
            return "error";
            // return { exception: row.exception };
        }

    }

    const onFakeDetails = (row, content_type) => {
        setDetails({
            ...row,
            content_type,
            current: true
        });
    }

    const getCurrentDetails = (row, content_type) => {
        return <Link onClick={() => onFakeDetails(row, content_type)}>Show cached data</Link>;
    }

    const copyDataToClipboard = () => {
        const text = JSON.stringify(details.data, null, 2);
        console.log('copy', text);
        copyTextToClipboard(text.toString());
        enqueueSnackbar("Data copied!", { variant: 'success', autoHideDuration: 500 })
    }

    return (
        details ?
        <Modal
            open={props.open}
            onClose={onClose}
                style={{ zIndex: 10003 }}

        >
            <div className={classes.modalContent}>
            <Typography variant="h6">
                <IconButton size="small" onClick={onCloseData}><ArrowBackOutlinedIcon/></IconButton> 
                    { details.current ? 
                        <>Current cache data ({details.content_type.app_label}.{details.content_type.model}.{props.id})</> : <>Cache refresh record ({data.content_type.app_label}.{data.content_type.model}.{props.id})</> }
                </Typography>
                <TableContainer component={Paper}>
                    { details.current ?
                    <>
                    <Table>
                        <TableHead className={classes.tableHead}>
                            <TableRow className={classes.tableHeadRow}>
                                <TableCell className={classes.tableHeadCell}>Version</TableCell>
                                <TableCell className={classes.tableHeadCell}>Log ID</TableCell>
                                <TableCell className={classes.tableHeadCell}>Timestamp</TableCell>
                                <TableCell className={classes.tableHeadCell}>Size</TableCell>
                                <TableCell className={classes.tableHeadCell}>Specification</TableCell>
                                <TableCell className={classes.tableHeadCell}>CDN</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className={classes.tableBody}>
                            <TableRow className={classes.tableRow}>
                                <TableCell className={classes.tableCell}>{details.api_type}/{details.version}</TableCell>
                                <TableCell className={classes.tableCell}>{details.logid}</TableCell>
                                <TableCell className={classes.tableCell}>{moment(details.timestamp).format("MMM DD, YYYY HH:mm:ss Z")}</TableCell>
                                <TableCell className={classes.tableCell}>{details.size}{details.src ? ` (${details.src})` : ''}</TableCell>
                                <TableCell className={classes.tableCell}>{details.spec_version}</TableCell>
                                <TableCell className={classes.tableCell}>
                                    {details.url && details.url_data_size ? <>
                                        <Link href={details.url} target="_blank">{details.url_data_size} bytes</Link>
                                    </>: <>&mdash;</> }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={6} style={{ position: 'relative' }}>
                                    <IconButton title="Copy data to clipboard" onClick={copyDataToClipboard} style={{
                                        opacity: 0.5,
                                        position: 'absolute',
                                        left: '20px',
                                        top: '10px',
                                    }}><FileCopyOutlinedIcon/></IconButton>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <pre style={{ marginTop: '10px', width: '100%', overflowX: 'scroll' }}>
                        {JSON.stringify(details.data, null, 2)}
                    </pre>
                    </>
                :
                    <Table>
                        <TableHead className={classes.tableHead}>
                            <TableRow className={classes.tableHeadRow}>
                                <TableCell className={classes.tableHeadCell}>Log ID</TableCell>
                                <TableCell className={classes.tableHeadCell}>Start date</TableCell>
                                <TableCell className={classes.tableHeadCell}>Duration</TableCell>
                                <TableCell className={classes.tableHeadCell}>Action</TableCell>
                                <TableCell className={classes.tableHeadCell}>Status</TableCell>
                                <TableCell className={classes.tableHeadCell}>Specification</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className={classes.tableBody}>
                            <TableRow>
                                <TableCell className={classes.tableCell}>{details.logid}</TableCell>
                                <TableCell className={classes.tableCell}>{moment(details.start_ts).format("MMM DD, YYYY HH:mm:ss Z")}</TableCell>
                                <TableCell className={classes.tableCell}>{details.duration}</TableCell>
                                <TableCell className={classes.tableCell}>{getActionDisplay(details.action)}</TableCell>
                                <TableCell className={classes.tableCell}>{getStatusDisplay(details.status)}</TableCell>
                                <TableCell className={classes.tableCell}>{details.spec_version}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={6} style={{ position: 'relative' }}>
                                    <IconButton title="Copy data to clipboard" onClick={copyDataToClipboard} style={{
                                        opacity: 0.5,
                                        position: 'absolute',
                                        left: '20px',
                                        top: '10px',
                                    }}><FileCopyOutlinedIcon/></IconButton>
                                    <pre style={{ marginTop: '10px' }}>
                                        {JSON.stringify(details.data, null, 2)}
                                    </pre>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    }
                </TableContainer>
            </div>

        </Modal>
        :
        <Modal
            open={props.open}
            onClose={onClose}
                style={{ zIndex: 10003 }}
            >
            <div className={classes.modalContent}>
                { current ? 
                <>
                    <Typography variant="h6">Current cache state ({current.content_type.app_label}.{current.content_type.model}.{props.id})</Typography>
                    { current.results.length ?
                    <>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead className={classes.tableHead}>
                                    <TableRow className={classes.tableHeadRow}>
                                        <TableCell className={classes.tableHeadCell}>Version</TableCell>
                                        <TableCell className={classes.tableHeadCell}>Log ID</TableCell>
                                        <TableCell className={classes.tableHeadCell}>Timestamp</TableCell>
                                        <TableCell className={classes.tableHeadCell}>Size</TableCell>
                                        <TableCell className={classes.tableHeadCell}>Specification</TableCell>
                                        <TableCell className={classes.tableHeadCell}>CDN</TableCell>
                                        <TableCell className={classes.tableHeadCell}>Details</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.tableBody}>
                                    { (current.results || []).map((row, rowIdx) => {
                                        const details = getCurrentDetails(row, current.content_type);
                                        return <TableRow className={classes.tableRow} key={rowIdx}>
                                            <TableCell className={classes.tableCell}>{row.api_type}/{row.version}</TableCell>
                                            <TableCell className={classes.tableCell}>{row.logid}</TableCell>
                                            <TableCell className={classes.tableCell}>{moment(row.timestamp).format("MMM DD, YYYY HH:mm:ss Z")}</TableCell>
                                            <TableCell className={classes.tableCell}>{row.size}{row.src ? ` (${row.src})` : ''}</TableCell>
                                            <TableCell className={classes.tableCell}>{row.spec_version}</TableCell>
                                            <TableCell className={classes.tableCell}>
                                                {row.url && row.url_data_size ? <>
                                                    <Link href={row.url} target="_blank">{row.url_data_size} bytes</Link>
                                                </>: <>&mdash;</> }
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>{details}</TableCell>
                                        </TableRow>;

                                    }) }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                    : <Typography variant="body2">Object is not in cache</Typography>
                    }
                </>
                :
                    <Box className={classes.root} display="flex" alignItems="flex-start" justifyContent="center" >
                        <Grid container direction="row" spacing={4} alignItems="center">
                            <Grid item xs={2}><CircularProgress color="primary"/></Grid>
                            <Grid item xs={10}>Loading cache refresh history. Please wait...</Grid>
                        </Grid>
                    </Box>                        
                }
                { data ? 
                <>
                    <Box style={{ paddingTop: theme.spacing(2) }}>
                    <Typography variant="h6">Cache refresh history ({data.content_type.app_label}.{data.content_type.model}.{props.id})</Typography>
                    { data.results.length ?
                        <>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead className={classes.tableHead}>
                                        <TableRow className={classes.tableHeadRow}>
                                            <TableCell className={classes.tableHeadCell}>Log ID</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Start date</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Duration</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Action</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Status</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Specification</TableCell>
                                            <TableCell className={classes.tableHeadCell}>Details</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className={classes.tableBody}>
                                        { (data.results || []).map((row, rowIdx) => {
                                            const details = getDetails(row);
                                            const cname = clsx({
                                                [classes.tableRow]: true,
                                                [classes.tableRowValidation]: +row.status === 2,
                                                [classes.tableRowException]: +row.status === 5,
                                            })
                                            return <TableRow className={cname} key={rowIdx} data-status={row.status === 2}>
                                                <TableCell className={classes.tableCell}>{row.logid}</TableCell>
                                                <TableCell className={classes.tableCell}>{moment(row.start_ts).format("MMM DD, YYYY HH:mm:ss Z")}</TableCell>
                                                <TableCell className={classes.tableCell}>{row.duration}</TableCell>
                                                <TableCell className={classes.tableCell}>{getActionDisplay(row.action)}</TableCell>
                                                <TableCell className={classes.tableCell}>{getStatusDisplay(row.status)}</TableCell>
                                                <TableCell className={classes.tableCell}>{row.spec_version}</TableCell>
                                                <TableCell className={classes.tableCell}>{details}</TableCell>
                                            </TableRow>;
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <p>
                            <Typography variant="body2">
                                Showing last { Math.min(data.count, data.page_size)} records out of {data.count} total
                            </Typography>
                            </p>
                        </>
                        : <Typography variant="body2">No cache refresh history recorded</Typography>
                    }
                    </Box>
                </>
                : <Box style={{ paddingTop: theme.spacing(2) }}>
                    <Button variant="contained" color="primary" onClick={onLoadList}>Show cache refresh history</Button>
                </Box> }
            </div>
        </Modal>
    )
}

export default CacheRefreshHistory
